<template>
  <b-navbar
    toggleable="md"
    fixed="top"
    type="dark"
    variant="light"
    :class="{ 'main-navbar': disabledNavbar }"
  > 
    <ProfileWithMenu :userInfo="userInfo" :disabledNavbar="disabledNavbar" />
    <div class="search-con">
      <i class="fa fa-search search-icon"></i>
      <input type="text" class="search-bar" placeholder="Search" @keyup.enter="handleSearch()" v-model="searchKeyword" />
    </div>
    <b-navbar-brand href="https://public.carriercommunity.com/" class="logo">
      <img
        class="logoImg"
        :src="require('@/assets/logo/logo_small.png')"
        alt
    /></b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="mr-auto">
        <b-nav-item
          :class="!disabledNavbar ? 'icons' : 'icons-disabled'"
          to="/personal-wall"
          target="_self"
          exact
          @mouseover="homeIcon = 'icons_top__Home__hover.png'"
          @mouseout="homeIcon = 'icons_top__Home.png'"
        >
          <img
            :src="
              $route.path === '/personal-wall'
                ? require('@/assets/menuIcons/icons_top__Home__hover.png')
                : require(`@/assets/menuIcons/${homeIcon}`)
            "
            alt="home"
            class="menu-icon"
          />
          <p class="icon-text">Home</p>
        </b-nav-item>
        <b-nav-item
          :class="!disabledNavbar ? 'icons' : 'icons-disabled'"
          :to="{ name: 'ccAllEvents' }"
          @mouseover="eventsIcon = 'icons_top__Events__hover.png'"
          @mouseout="eventsIcon = 'icons_top__Events.png'"
          exact
        >
          <img
            :src="
              $route.path === '/all-events'
                ? require('@/assets/menuIcons/icons_top__Events__hover.png')
                : require(`@/assets/menuIcons/${eventsIcon}`)
            "
            alt="events"
            class="menu-icon"
          />
          <p class="icon-text">Events</p>
        </b-nav-item>
        <b-nav-item
          :class="!disabledNavbar ? 'icons' : 'icons-disabled'"
          :to="{ name: 'ccMyEvents' }"
          @mouseover="myEventsIcon = 'icons_top__Events__hover.png'"
          @mouseout="myEventsIcon = 'icons_top__Events.png'"
          exact
        >
          <img
            :src="
              $route.path === '/my-events'
                ? require('@/assets/menuIcons/icons_top__Events__hover.png')
                : require(`@/assets/menuIcons/${myEventsIcon}`)
            "
            alt="events"
            class="menu-icon"
          />
          <p class="icon-text">My Events</p>
        </b-nav-item>
        <b-nav-item
          :class="[!disabledNavbar ? 'icons network' : 'icons-disabled network',]"
          @mouseover="networkIcon = 'icons_top__Network__hover.png'"
          @mouseout="networkIcon = 'icons_top__Network.png'"
        >
          <img
            :src="
             isMemberOrNetwork
                ? require('@/assets/menuIcons/icons_top__Network__hover.png')
                : require(`@/assets/menuIcons/${networkIcon}`)
            "
            alt="network"
            class="menu-icon"
          />
          <i
            class="nav-bar-notification-icons"
            v-if="unansweredNetworkRequestCount"
            >{{ unansweredNetworkRequestCount }}</i
          >
          <p :class="['icon-text', isMemberOrNetwork ? 'router-link-exact-active router-link-active' : '']">Network</p>
          <div class="arrow-down"></div>
          
          <div class="dropdown-content">
           <router-link :to="{ name: 'network' }" exact>
            <img
            :src="
              $route.path === '/network'
                ? require('@/assets/menuIcons/icons_top__Network__hover.png')
                : require(`@/assets/menuIcons/icons_top__Network.png`)
            "
            alt="network"
            class="menu-icon"
          /> My Network</router-link>
            <router-link :to="{ name: 'MembersList' }" exact>              
              <img
                :src="
                  $route.path === '/members'
                    ? require('@/assets/menuIcons/icons_top__Members__hover.png')
                    : require(`@/assets/menuIcons/${membersIcon}`)
                "
                alt="members"
                class="menu-icon"
              /> 
            Global Directory
            </router-link>
          </div>

        </b-nav-item>
        <!-- <b-nav-item
          :class="!disabledNavbar ? 'icons' : 'icons-disabled'"
          :to="{ name: 'MembersList' }"
          @mouseover="membersIcon = 'icons_top__Members__hover.png'"
          @mouseout="membersIcon = 'icons_top__Members.png'"
          exact
        >
          <img
            :src="
              $route.path === '/members'
                ? require('@/assets/menuIcons/icons_top__Members__hover.png')
                : require(`@/assets/menuIcons/${membersIcon}`)
            "
            alt="members"
            class="menu-icon"
          />
          <p class="icon-text">Members Directory</p>
        </b-nav-item> -->
        <!-- for later -->
        <!-- <b-nav-item
          :class="!disabledNavbar ? 'icons' : 'icons-disabled'"
          to="/"
          exact
        >
          <img src="" alt="" class="menu-icon">
          <p class="icon-text">Services</p>
        </b-nav-item> -->

          <b-nav-item
         :to="{ name: 'MediaArchive' }"
          :class="!disabledNavbar ? 'icons' : 'icons-disabled'"
          @mouseover="archiveIcon = 'icons_top__Archive__hover.png'"
          @mouseout="archiveIcon = 'icons_top__Archive.png'"
          exact
        >
          <img
             :src="
              $route.path === '/media-archive'
                ? require('@/assets/menuIcons/icons_top__Archive__hover.png')
                : require(`@/assets/menuIcons/${archiveIcon}`)
            "
            alt="media"
            class="menu-icon"
          />
          <p class="icon-text">Media Archive</p>
        </b-nav-item>
        <b-nav-item
         :to="{ name: 'MediaChannels' }"
          :class="!disabledNavbar ? 'icons' : 'icons-disabled'"
          @mouseover="mediaIcon = 'icons_top__Media__hover.png'"
          @mouseout="mediaIcon = 'icons_top__Media.png'"
          exact
        >
          <img
             :src="
              $route.path === '/media-channels'
                ? require('@/assets/menuIcons/icons_top__Media__hover.png')
                : require(`@/assets/menuIcons/${mediaIcon}`)
            "
            alt="media"
            class="menu-icon"
          />
          <p class="icon-text">Media Channels</p>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item
          :class="!disabledNavbar ? 'icons' : 'icons-disabled'"
          :to="{ name: 'Messages' }"
          @mouseover="messagesIcon = 'icons_top__Messages__hover.png'"
          @mouseout="messagesIcon = 'icons_top__Messages.png'"
          exact
        >
          <img
            :src="
              $route.path === '/messages'
                ? require('@/assets/menuIcons/icons_top__Messages__hover.png')
                : require(`@/assets/menuIcons/${messagesIcon}`)
            "
            alt="messages"
            class="menu-icon"
          />
          <i
            class="nav-bar-notification-icons"
            v-if="unreadMessagesCount > 0"
            >{{ unreadMessagesCount }}</i
          >
          <p class="icon-text">Messages</p>
        </b-nav-item>
        <b-nav-item
          :class="!disabledNavbar ? 'icons' : 'icons-disabled'"
          :to="{ name: 'AllNotifications' }"
          @mouseover="notificationsIcon = 'icons_top__Notifications__hover.png'"
          @mouseout="notificationsIcon = 'icons_top__Notifications.png'"
          exact
        >
          <img
            :src="
              $route.path === '/notifications'
                ? require('@/assets/menuIcons/icons_top__Notifications__hover.png')
                : require(`@/assets/menuIcons/${notificationsIcon}`)
            "
            alt="notifications"
            class="menu-icon"
          />
          <i class="nav-bar-notification-icons" v-if="newNotifsCount">{{
            newNotifsCount
          }}</i>
          <p class="icon-text">Notifications</p>
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import getIDfromURL from '../utils/getIDfromURL';
import ProfileWithMenu from './ProfileWithMenu.vue';

export default {
  name: 'NavbarPersonal',
  components: {
    ProfileWithMenu
  },
  data() {
    return {
      searchIcon: 'icons_top__Search.png',
      homeIcon: 'icons_top__Home.png',
      eventsIcon: 'icons_top__Events.png',
      myEventsIcon: 'icons_top__Events.png',
      logoutIcon: 'icons_top__Logout.png',
      mediaIcon: 'icons_top__Media.png',
      archiveIcon: 'icons_top__Archive.png',
      membersIcon: 'icons_top__Members.png',
      messagesIcon: 'icons_top__Messages.png',
      networkIcon: 'icons_top__Network.png',
      notificationsIcon: 'icons_top__Notifications.png',
      wallIcon: 'icons_top__Wall.png',
      users: [],
      page: 1,
      notificationCount: 0,
      searchKeyword: '',
    };
  },
  props: {
    disabledNavbar: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/fetchUserInfo',
      newNotifsCount: 'notifications/newNotifsCount',
      unreadMessagesCount: 'messages/unreadMessagesCount',
      unansweredNetworkRequestCount: 'user/unansweredNetworkRequestCount',
    }),
    isMemberOrNetwork() {
      return this.$route.path.includes('members') || this.$route.path.includes('network');
    },
  },
  async mounted() {
    await this.getUnreadMessagesCount();
  },
  methods: {
    ...mapActions({
      userLogout: 'auth/userLogout',
      getUnreadMessagesCount: 'messages/getUnreadMessagesCount',
    }),
    async logOut() {
      await this.userLogout();
      this.$router.push({ name: 'signIn' });
    },
    getId(url) {
      return getIDfromURL(url);
    },
    handleSearch() {
      this.$router.push({ name: 'GlobalSearch', query: { query: this.searchKeyword } });
      this.searchKeyword = '';
    },
  },
};
</script>
<style src="./NavbarPersonal.css" scoped></style>
